export class SignupPolicyError extends Error {}

// Read only on a deliberate signup attempt. Never poll or expose an admin key.
export async function requireOwnerApprovalSignup(
  supabaseUrl: string,
  publicKey: string,
  fetcher: typeof fetch = fetch,
  timeoutMs = 8_000,
) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetcher(`${supabaseUrl.replace(/\/+$/, "")}/auth/v1/settings`, {
      headers: { apikey: publicKey }, signal: controller.signal, cache: "no-store",
    });
    if (!response.ok) throw new Error("Auth settings unavailable");
    const settings = await response.json();
    if (settings?.disable_signup === true || settings?.external?.email === false)
      throw new SignupPolicyError("Pendaftaran akun belum dibuka. Hubungi Owner.");
    if (settings?.mailer_autoconfirm !== true)
      throw new SignupPolicyError("Pendaftaran tanpa konfirmasi email belum diaktifkan. Hubungi Owner untuk menyiapkan pendaftaran akun.");
  } catch (error) {
    if (error instanceof SignupPolicyError) throw error;
    throw new SignupPolicyError("Pengaturan pendaftaran belum dapat diperiksa. Coba lagi setelah koneksi tersedia.");
  } finally { clearTimeout(timeout); }
}
